import {
    DELETE_MIS_DATA_LOG,
    DELETE_MIS_DATA_LOG_FAIL,
    DELETE_MIS_DATA_LOG_SUCCESS,
    GET_MIS_DATA_LOG_DETAILS,
    GET_MIS_DATA_LOG_DETAILS_FAIL,
    GET_MIS_DATA_LOG_DETAILS_SUCCESS,
    MIS_DATA_LOG_CREATE,
    MIS_DATA_LOG_CREATE_FAIL,
    MIS_DATA_LOG_CREATE_SUCCESS,
    RESET,
    RESET_MIS_DATA_LOG_CREATE,
    RESET_MIS_DATA_LOG_DETAILS,
    UPDATE_MIS_DATA_LOG,
    UPDATE_MIS_DATA_LOG_FAIL,
    UPDATE_MIS_DATA_LOG_SUCCESS,
} from "./actionsTypes";

const initialState = {
    MISDataLogList: [],
    MISDataLogDetails: {},
    createResult: {},
    loading: false,
    detailsLoading: false,
    loadingCreate: false,
    error: {
        message: "",
    },
};

const MISDataLogReducer = (state = initialState, action) => {
    if (!action) return state;

    switch (action.type) {
        case MIS_DATA_LOG_CREATE:
            state = { ...state, createResult: {}, loadingCreate: true };
            break;
        case MIS_DATA_LOG_CREATE_SUCCESS:
            state = { ...state, createResult: action.payload, loadingCreate: false };
            break;
        case MIS_DATA_LOG_CREATE_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                createResult: {},
                loadingCreate: false,
            };
            break;

        //GET individual MIS Data Log
        case GET_MIS_DATA_LOG_DETAILS:
            state = { ...state, detailsLoading: true, MISDataLogDetails: {} };
            break;
        case GET_MIS_DATA_LOG_DETAILS_SUCCESS:
            state = { ...state, MISDataLogDetails: action.payload, detailsLoading: false };
            break;
        case GET_MIS_DATA_LOG_DETAILS_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                detailsLoading: false,
            };
            break;

        //Update individual MIS Data Log
        case UPDATE_MIS_DATA_LOG:
            state = { ...state, createResult: {}, loading: true };
            break;
        case UPDATE_MIS_DATA_LOG_SUCCESS:
            state = { ...state, createResult: action.payload, loading: false };
            break;
        case UPDATE_MIS_DATA_LOG_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                loading: false
            };
            break;

        //Delete individual MIS Data Log
        case DELETE_MIS_DATA_LOG:
            state = { ...state, deleteResult: {}, loading: true, };
            break;
        case DELETE_MIS_DATA_LOG_SUCCESS:
            state = { ...state, deleteResult: action.payload, loading: false };
            break;
        case DELETE_MIS_DATA_LOG_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                loading: false,
                deleteResult: {}
            };
            break;

        //Reset MIS Data Log
        case RESET_MIS_DATA_LOG_DETAILS:
            state = { ...state, MISDataLogDetails: {}, detailsLoading: false };
            break;

        case RESET:
            state = { ...state, MISDataLogList: [], createResult: {} };
            break;
        case RESET_MIS_DATA_LOG_CREATE:
            state = { ...state, createResult: {} };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
};

export default MISDataLogReducer;